const GOOGLE_AUTH_ENDPOINT = 'https://accounts.google.com/o/oauth2/v2/auth';

export function startGoogleWebOAuth() {
  if (typeof window === 'undefined') {
    return;
  }

  const clientId = import.meta.env.VITE_GOOGLE_WEB_CLIENT_ID;

  if (!clientId) {
    console.error('[GoogleWebAuth] VITE_GOOGLE_WEB_CLIENT_ID is not set');
    return;
  }

  const redirectUri = `${window.location.origin}/auth/google`;

  const nonce =
    (window.crypto && 'randomUUID' in window.crypto
      ? window.crypto.randomUUID()
      : Math.random().toString(36).slice(2)) || '';

  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: 'id_token',
    scope: 'openid email profile',
    nonce,
    prompt: 'select_account',
  });

  const authUrl = `${GOOGLE_AUTH_ENDPOINT}?${params.toString()}`;
  window.location.href = authUrl;
}

